<mat-card>
    <div class="marginHeader">

        <form class="form-group bg-light -p5" [formGroup]="formSearch" (ngSubmit)="submitForm()">

            <div class="row">
                <div class="col-12 col-md-3 col-lg-3 col-xl-1">
                    <mat-form-field class="wd-100 customSelect" appearance="fill">
                        <mat-label>{{ 'CASHIERMANAGEMENT.start' | translate }}</mat-label>

                        <input matInput [matDatepicker]="pickerDateOpen" formControlName="dateOpen"
                            [placeholder]="'CASHIERMANAGEMENT.start' | translate" />

                        <mat-datepicker-toggle matSuffix [for]="pickerDateOpen">
                        </mat-datepicker-toggle>

                        <mat-datepicker #pickerDateOpen></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="col-12 col-md-3 col-lg-3 col-xl-1">
                    <mat-form-field class="wd-100 customSelect" appearance="fill">
                        <mat-label>{{ 'CASHIERMANAGEMENT.final' | translate }}</mat-label>

                        <input matInput [matDatepicker]="pickerDateClose" formControlName="dateClose"
                            [placeholder]="'CASHIERMANAGEMENT.final' | translate" />

                        <mat-datepicker-toggle matSuffix [for]="pickerDateClose">
                        </mat-datepicker-toggle>

                        <mat-datepicker #pickerDateClose></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="col-12 col-md-3 col-lg-3 col-xl-2">
                    <mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'" appearance="fill">
                        <mat-label>{{"Batch Type" | translate}}</mat-label>
                        <mat-select formControlName="journalType">
                            <mat-option *ngFor="let item of journalTypes" [value]="item">
                                {{'JournalType.' + item.journalType | translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-12 col-md-3 col-lg-3 col-xl-1">
                    <mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'" appearance="fill">
                        <mat-label>Mês</mat-label>
                        <mat-select formControlName="month">
                            <mat-option *ngFor="let month of months" [value]="month.id">{{month.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-12 col-md-3 col-lg-3 col-xl-1">
                    <mat-form-field class="wd-100" [floatLabel]="'auto'" appearance="fill">
                        <mat-label>Ano</mat-label>
                        <!-- Input visível, exibe o ano numérico, é somente leitura -->
                        <input matInput formControlName="year" readonly placeholder="Ano">
                        <!-- Input oculta para vincular o mat-datepicker ao formControl auxiliar (yearPickerHelperControl) -->
                        <input [matDatepicker]="dpYear" [formControl]="yearPickerHelperControl" style="display: none;">
                        <mat-datepicker-toggle matSuffix [for]="dpYear"></mat-datepicker-toggle>
                        <mat-datepicker #dpYear (yearSelected)="yearSelectedHandler($event, dpYear)"
                            startView="multi-year" panelClass="year-picker">
                        </mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="col-12 col-md-3 col-lg-3 col-xl-1">
                    <mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'" appearance="fill">
                        <mat-label>{{'Número' | translate}}</mat-label>
                        <input matInput formControlName="number">
                    </mat-form-field>
                </div>

                <div class="col-12 col-md-3 col-lg-3 col-xl-2">
                    <mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'" appearance="fill">
                        <mat-label>Nome de Usuário</mat-label>
                        <input matInput formControlName="userName">
                    </mat-form-field>
                </div>

                <div class="col-12 col-md-3 col-lg-3 col-xl-1">
                    <mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'" appearance="fill">
                        <mat-label>Status</mat-label>
                        <mat-select formControlName="journalStatusId">
                            <mat-option *ngFor="let status of journalStatusList" [value]="status.id">
                                {{'JournalStatus.' + status.name | translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-12 col-md-6 col-lg-6 col-lg-4 col-xl-2 d-flex align-items-start justify-content-evenly">
                    <button type="submit" class="btn btn-primary mt-2 me-2 mr-2 flex-fill"><span
                            style="white-space: nowrap;"><i class="flaticon2-search"></i>Filtrar</span></button>
                    <button type="button" class="btn btn-secondary mt-2 ml-2 flex-fill" (click)="clearForm()"><span
                            style="white-space: nowrap;"><i class="flaticon2-rubbish-bin"></i>Limpar</span></button>
                </div>
            </div>
        </form>
    </div>
    <hr />

    <div *ngIf="resOk && dataSource.length > 0">
        <simple-list [data]="dataSource" [config]="simpleTableConfig" (reloadTable)="reloadTable($event)">
        </simple-list>
    </div>

    <div *ngIf="resOk && dataSource.length === 0">
        <mat-card>
            <p class="notData">Nenhum resultado encontrado para esse filtro</p>
        </mat-card>
    </div>

    <loader></loader>
</mat-card>
